import { Form, FormField } from "common/Forms"
import { PrimaryButton } from "common/Forms/button"
import { DateInput, SelectInput, TextInput } from "common/Forms/inputs"
import { Grid, GridCell } from "common/Grid/Grid";
import { ScreenSizes, useScreenSizes } from "common/Grid/useScreenSize";
import { statusOptionsProvider } from "Constant/Constant";
import { useState } from "react"

export const AdvanceSearchForm = ({ siteIdOptions, userInput, setUserInput, onApply, onClear }) => {
  const screenSize = useScreenSizes();
  const columns = screenSize === ScreenSizes.Large ? 4 : screenSize === ScreenSizes.Medium ? 2 : 1;
  const [openEndDate, setOpenEndDate] = useState(false);
  const [openStartDate, setOpenStartDate] = useState(false);

  return (
    <Form>
      <Grid columns={columns}>
        <GridCell>
          <FormField
            id="status"
            label="Status"
            inputFactory={(id, name, onValidition) =>
              <SelectInput disabled={false}
                id={id} name={name}
                placeholder={"Select status"}
                selectedKey={userInput.status}
                optionProvider={() => statusOptionsProvider}
                keySelector={(x => `${x.value}`)}
                labelSelector={(x => `${x.label}`)}
                onValidation={onValidition}
                onChange={(_, n, selector) => setUserInput((prev) => ({ ...prev, status: n ? selector(n) : '' }))} />
            } />
        </GridCell>
        <GridCell>
          <FormField
            id="siteid"
            label="Site ID"
            inputFactory={(id, name, onValidition) =>
              <SelectInput disabled={false}
                id={id} name={name}
                placeholder="Select site id"
                selectedKey={userInput.siteid}
                optionProvider={() => siteIdOptions}
                keySelector={(x => `${x.value}`)}
                isClearable={false}
                labelSelector={(x => `${x.label}`)}
                onValidation={onValidition}
                onChange={(_, n, selector) => setUserInput((prev) => ({ ...prev, siteid: n ? selector(n) : '' }))} />
            } />
        </GridCell>
        <GridCell>
          <FormField
            id="orderId"
            label="Order ID"
            classNames={["text_input_box"]}
            inputFactory={(id, name, onValidition) =>
              <TextInput
                id={id} name={name}
                disabled={false}
                placeholder="Search by order id"
                value={userInput.orderId}
                onValidation={onValidition}
                onChange={(_, n) => setUserInput((prev) => ({ ...prev, orderId: n }))} />
            } />
        </GridCell>
        <GridCell>
          <FormField
            id="start_date"
            name='Start date'
            label="Start Date"
            inputFactory={(id, name, onValidation) =>
              <DateInput
                id={id}
                name={name}
                disabled={false}
                placeholder="Select start date"
                value={userInput?.startDateFrom}
                // maxDate={userInput?.endDateFrom || undefined}
                onValidation={onValidation}
                open={openStartDate}
                onCalendarClose={() => setOpenStartDate(false)}
                onChange={(_, n) => {
                  const startDate = n ? new Date(n) : "";
                  const endDate = userInput?.endDateFrom ? new Date(userInput.endDateFrom) : null;

                  setOpenStartDate(false);
                  if (endDate && startDate && startDate > endDate) {
                    setUserInput((prev) => ({ ...prev, startDateFrom: startDate, endDateFrom: "" }));
                    setOpenEndDate(true);
                  } else if (n && !userInput?.endDateFrom) {
                    setUserInput((prev) => ({ ...prev, startDateFrom: startDate }));
                    setOpenEndDate(true);
                  } else if (!n) {
                    setUserInput((prev) => ({ ...prev, startDateFrom: startDate, endDateFrom: "" }));
                    setOpenEndDate(false);
                  } else {
                    setUserInput((prev) => ({ ...prev, startDateFrom: startDate }));
                    setOpenEndDate(false);
                  }
                }} />
            }
          />
        </GridCell>
        <GridCell>
          <FormField
            id="end_date"
            name='End date'
            label="End Date"
            inputFactory={(id, name, onValidation) => (
              <DateInput
                id={id}
                name={name}
                disabled={false}
                placeholder="Select end date"
                value={userInput?.endDateFrom || undefined}
                minDate={userInput?.startDateFrom || undefined}
                onValidation={onValidation}
                open={openEndDate}
                onCalendarClose={() => setOpenEndDate(false)}
                onChange={(_, n) => {
                  const endDate = n ? new Date(n) : "";
                  const startDate = userInput?.startDateFrom ? new Date(userInput.startDateFrom) : null;

                  setOpenEndDate(false);
                  const shouldOpenStartDate = n && !userInput?.startDateFrom;
                  if (startDate && endDate && endDate < startDate) {
                    setUserInput((prev) => ({ ...prev, endDateFrom: endDate, startDateFrom: "" }));
                  } else {
                    setUserInput((prev) => ({ ...prev, endDateFrom: endDate }));
                  }

                  setOpenStartDate(!!shouldOpenStartDate);
                }}
              />
            )}
          />
        </GridCell>
        <GridCell column={columns} vertical="bottom">
          <Grid columns={2} columnGap={1}>
            <GridCell>
              <PrimaryButton action={onApply} isWide={true} classNames={["justify-center"]}>
                Apply Filters
              </PrimaryButton>
            </GridCell>
            <GridCell>
              <PrimaryButton action={onClear} isWide={true} classNames={["justify-center"]}>
                Clear Filters
              </PrimaryButton>
            </GridCell>
          </Grid>
        </GridCell>
      </Grid>
    </Form>
  )
}
